<script>
import Layout from "@/views/layouts/main.vue";
import CommonTableComponent from "@/components/table.vue";
import apiEndpoints from "@/services/apiEndpoints";
import http from "@/services/http";
import appConfig from "@/app.config.json";

export default {
  name: "DetailContract",
  page: {
    title: "処分契約詳細",
    meta: [{ name: "description", content: appConfig.description }]
  },
  data() {
    return {
      treatmentContract: {
        "case": {
          "discharger": {},
          "discharger_site": {},
        },
        "waste_category_by_contract": [],
        "vendor": {}
      }
    };
  },
  components: {
    Layout,
    CommonTableComponent
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;

      const url = apiEndpoints.projects_sales_contracts_detail(this.$route.params.id, this.$route.params.contract_id);

      const sendApiProject = await http.get(url, {});
      const { status, data } = sendApiProject;
      if (status) {
        this.treatmentContract = data.result;
      }

      this.isLoading = false;
    },
    backToList() {
      let query = (localStorage.getItem('projects/sales/contract') == null)
        ? { activeTabIndex: this.$constant.pages.project.sales.contract.tabIndex }
        : JSON.parse(localStorage.getItem('projects/sales/contract'))
      this.$router.push({
        name: "projects.sales",
        params: { id: this.projectId },
        query: query
      });
    },
    displayPermit(key) {
      let result = [];
      if (!this.treatmentContract) return '';
      if (!this.treatmentContract[key]) return '';

      if (this.treatmentContract[key].vendor && this.treatmentContract[key].vendor.name_abbreviated) {
        result.push(this.treatmentContract[key].vendor.name_abbreviated);
      }

      if (this.treatmentContract[key].zz_municipality.municipality && this.treatmentContract[key].zz_municipality.municipality) {
        result.push(this.treatmentContract[key].zz_municipality.municipality);
      }

      if (this.treatmentContract[key].permit_number) {
        result.push(this.treatmentContract[key].permit_number);
      }

      return result.join(" ")
    },
    displayLink(){
      return !(this.treatmentContract.ni_id == null);
    },
    toNI(){
      if(!this.treatmentContract.ni_id) return "";
      return this.$constant.ni_treatment_contract_uri + this.treatmentContract.ni_id;
    }
  },
  computed: {
    projectId() {
      return this.$route.params.id;
    },
    contractId() {
      return this.$route.params.contract_id;
    }
  }
};
</script>
<template>
  <Layout>
    <b-container fluid>
      <div class="d-flex justify-content-end mb-2">
        <b-button variant="primary" size="lg" @click="backToList()">{{
            this.$lang.button.back
          }}</b-button>
      </div>
      <b-card :show="isLoading">
        <b-row v-if="displayLink()">
          <div class="content-block mb-3">
          <a target="_blank" :href="toNI()">
            NIコラボ上での契約情報・添付ファイルの確認はこちら
          </a>
          <i class="fas fa-clone"></i>
          </div>
        </b-row>
      
        <b-row>
          <div class="table-responsive">
            <table
              class="table table-hover table-borderless align-middle table-centered table-nowrap mb-0 table-striped"
            >
              <thead class="table-light">
              <tr>
                <th>CB管理番号</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>{{ treatmentContract.treatment_contract_cd }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </b-row>
        <b-row>
          <div class="content-block mt-3">
            <div class="title title-bg-green">契約基本情報</div>
            <div class="table-responsive">
              <table
                class="table table-bordered align-middle table-centered table-nowrap mb-0 table-striped"
              >
                <tbody>
                <tr>
                  <th>処分契約名</th>
                </tr>
                <tr>
                  <td>
                    <p>{{ treatmentContract.treatment_contract_name }}</p>
                  </td>
                </tr>
                <tr>
                  <th>商流*</th>
                </tr>
                <tr>
                  <td>
                    <p v-if="treatmentContract.case">{{ treatmentContract.case.case_name }}</p>
                  </td>
                </tr>
                <tr>
                  <th>事業者</th>
                </tr>
                <tr>
                  <p v-if="treatmentContract.case.discharger">{{ treatmentContract.case.discharger.name_abbreviated }}</p>
                </tr>
                <tr>
                  <th>事業場</th>
                </tr>
                <tr>
                  <td>
                    <p v-if="treatmentContract.case.discharger_site">{{ treatmentContract.case.discharger_site.name_abbreviated }}</p>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </b-row>
        <b-row>
          <div class="content-block mt-3">
            <div class="title title-bg-green">処分事業場情報</div>
            <div class="table-responsive">
              <table
                class="table table-bordered align-middle table-centered table-nowrap mb-0 table-striped"
              >
                <tbody>
                <tr>
                  <th colspan="4">処分事業者*</th>
                </tr>
                <tr>
                  <td colspan="4">
                    <p>{{ treatmentContract.vendor.name_abbreviated }}</p>
                  </td>
                </tr>
                <tr>
                  <th colspan="4">処分事業場1</th>
                </tr>
                <tr>
                  <td colspan="4">
                    <p v-if="treatmentContract.vendor_site1">{{ treatmentContract.vendor_site1.name_abbreviated }}</p>
                  </td>
                </tr>
                <tr>
                  <th>都道府県</th>
                  <th>市区町村</th>
                  <th>町域</th>
                  <th>番地・建物名</th>
                </tr>
                <tr>
                  <td>
                    <p v-if="treatmentContract.vendor_site1">{{ treatmentContract.vendor_site1.address_1 }}</p>
                  </td>
                  <td>
                    <p v-if="treatmentContract.vendor_site1">{{ treatmentContract.vendor_site1.address_2 }}</p>
                  </td>
                  <td>
                    <p v-if="treatmentContract.vendor_site1">{{ treatmentContract.vendor_site1.address_3 }}</p>
                  </td>
                  <td>
                    <p v-if="treatmentContract.vendor_site1">{{ treatmentContract.vendor_site1.address_4 }}</p>
                  </td>
                </tr>
                <tr>
                  <th colspan="4">処分事業場2</th>
                </tr>
                <tr>
                  <td colspan="4">
                    <p v-if="treatmentContract.vendor_site2">{{ treatmentContract.vendor_site2.name_abbreviated }}</p>
                  </td>
                </tr>
                <tr>
                  <th>処分事業場2　都道府県</th>
                  <th>処分事業場2　市区町村</th>
                  <th>処分事業場2　町域</th>
                  <th>処分事業場2　番地・建物名</th>
                </tr>
                <tr>
                  <td>
                    <p v-if="treatmentContract.vendor_site2">{{ treatmentContract.vendor_site2.address_1 }}</p>
                  </td>
                  <td>
                    <p v-if="treatmentContract.vendor_site2">{{ treatmentContract.vendor_site2.address_2 }}</p>
                  </td>
                  <td>
                    <p v-if="treatmentContract.vendor_site2">{{ treatmentContract.vendor_site2.address_3 }}</p>
                  </td>
                  <td>
                    <p v-if="treatmentContract.vendor_site2">{{ treatmentContract.vendor_site2.address_4 }}</p>
                  </td>
                </tr>
                <tr>
                  <th colspan="4">処分事業場3</th>
                </tr>
                <tr>
                  <td colspan="4">
                    <p v-if="treatmentContract.vendor_site3">{{ treatmentContract.vendor_site3.name_abbreviated }}</p>
                  </td>
                </tr>
                <tr>
                  <th>処分事業場3　都道府県</th>
                  <th>処分事業場3　市区町村</th>
                  <th>処分事業場3　町域</th>
                  <th>処分事業場3　番地・建物名</th>
                </tr>
                <tr>
                  <td>
                    <p v-if="treatmentContract.vendor_site3">{{ treatmentContract.vendor_site3.address_1 }}</p>
                  </td>
                  <td>
                    <p v-if="treatmentContract.vendor_site3">{{ treatmentContract.vendor_site3.address_2 }}</p>
                  </td>
                  <td>
                    <p v-if="treatmentContract.vendor_site3">{{ treatmentContract.vendor_site3.address_3 }}</p>
                  </td>
                  <td>
                    <p v-if="treatmentContract.vendor_site3">{{ treatmentContract.vendor_site3.address_4 }}</p>
                  </td>
                </tr>
                <tr>
                  <th colspan="4">処分事業場4</th>
                </tr>
                <tr>
                  <td colspan="4">
                    <p v-if="treatmentContract.vendor_site4">{{ treatmentContract.vendor_site4.name_abbreviated }}</p>
                  </td>
                </tr>
                <tr>
                  <th>処分事業場4　都道府県</th>
                  <th>処分事業場4　市区町村</th>
                  <th>処分事業場4　町域</th>
                  <th>処分事業場4　番地・建物名</th>
                </tr>
                <tr>
                  <td>
                    <p v-if="treatmentContract.vendor_site4">{{ treatmentContract.vendor_site4.address_1 }}</p>
                  </td>
                  <td>
                    <p v-if="treatmentContract.vendor_site4">{{ treatmentContract.vendor_site4.address_2 }}</p>
                  </td>
                  <td>
                    <p v-if="treatmentContract.vendor_site4">{{ treatmentContract.vendor_site4.address_3 }}</p>
                  </td>
                  <td>
                    <p v-if="treatmentContract.vendor_site4">{{ treatmentContract.vendor_site4.address_4 }}</p>
                  </td>
                </tr>
                <tr>
                  <th colspan="4">処分事業場5</th>
                </tr>
                <tr>
                  <td colspan="4">
                    <p v-if="treatmentContract.vendor_site5">{{ treatmentContract.vendor_site5.name_abbreviated }}</p>
                  </td>
                </tr>
                <tr>
                  <th>処分事業場5　都道府県</th>
                  <th>処分事業場5　市区町村</th>
                  <th>処分事業場5　町域</th>
                  <th>処分事業場5　番地・建物名</th>
                </tr>
                <tr>
                  <td>
                    <p v-if="treatmentContract.vendor_site5">{{ treatmentContract.vendor_site5.address_1 }}</p>
                  </td>
                  <td>
                    <p v-if="treatmentContract.vendor_site5">{{ treatmentContract.vendor_site5.address_2 }}</p>
                  </td>
                  <td>
                    <p v-if="treatmentContract.vendor_site5">{{ treatmentContract.vendor_site5.address_3 }}</p>
                  </td>
                  <td>
                    <p v-if="treatmentContract.vendor_site5">{{ treatmentContract.vendor_site5.address_4 }}</p>
                  </td>
                </tr>
                <tr>
                  <th colspan="4">産廃処分事業者許可情報</th>
                </tr>
                <tr>
                  <td colspan="4">
                    <p>
                      {{  displayPermit('permit_waste') }}
                    </p>
                  </td>
                </tr>
                <tr>
                  <th colspan="4">特管処分事業者許可情報</th>
                </tr>
                <tr>
                  <td colspan="4">
                    <p>
                      {{ displayPermit('permit_special_waste') }}
                    </p>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </b-row>
        <b-row>
          <div class="content-block mt-3">
            <div class="title title-bg-green">その他情報</div>
            <div class="table-responsive">
              <table
                class="table table-bordered align-middle table-centered table-nowrap mb-0 table-striped"
              >
                <tbody>
                <tr>
                  <th>委託契約有効期限</th>
                  <th>自動更新</th>
                </tr>
                <tr>
                  <td>
                    <p>{{ treatmentContract.expiration_date }}</p>
                  </td>
                  <td>
                    <p>{{ treatmentContract.is_term_continuation == 1 ? "あり" : "" }}</p>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </b-row>
        <b-row>
          <div class="content-block mt-3">
            <div class="title title-bg-green">委託する廃棄物の種類</div>
            <div class="title title-grey">処分契約廃棄物種類</div>
            <div class="table-responsive">
              <table
                class="table table-bordered align-middle table-centered table-nowrap mb-0 table-striped"
              >
                <tbody>
                  <tr>
                    <th>廃棄物種類</th>
                    <th>事前協議</th>
                    <th>事前協議有効期間</th>
                  </tr>
                  <tr v-for="wasteCategoryByContract in treatmentContract.waste_category_by_contract" v-if="treatmentContract.waste_category_by_contract">
                    <td>
                      <p>{{ wasteCategoryByContract.waste_category.name_abbreviated }}</p>
                    </td>
                    <td>
                      <p>{{ wasteCategoryByContract.is_prior_consultation ? "あり" : "なし" }}</p>
                    </td>
                    <td>
                      <p>{{ wasteCategoryByContract.prior_consultation_expiration_date }}</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </b-row>
      </b-card>
    </b-container>
  </Layout>
</template>
<style scoped lang="scss">
.content-block {
  .title {
    padding: 2px;
    color: #ffffff;
  }
  .title-bg-green {
    background-color: #2cb57e;
  }
  .title-bg-blue {
    background-color: #47bce8;
  }
  .title-grey {
    margin-top: 20px;
    background-color: #d8d9d8;
  }
}
</style>
